import { Navigate, Outlet } from 'react-router'
import { useOkta } from '@/features/auth/OktaContext'
import { useLocalAuth } from '@/features/auth/LocalAuthContext'
import { ROUTES } from '@/shared/routes'

export const PublicRoute = () => {
  const { isAuthenticated: isOktaAuthenticated } = useOkta()
  const { isAuthenticated: isLocalAuthenticated } = useLocalAuth()

  if (isOktaAuthenticated || isLocalAuthenticated) {
    return <Navigate to={ROUTES.HOME} replace />
  }
  return <Outlet />
}
